import React, {Component} from 'react';
import LinkConfirmDelete from './LinkConfirmDelete'

class StationLinkDelete extends Component {
  render() {
    const {station, onDelete} = this.props
    const content = `Chắc chắn xoá trạm ${station.Name}?`
    return <LinkConfirmDelete title="Xoá trạm" content={content} object={station} onOk={onDelete}/>
  }
}

export default StationLinkDelete;



// WEBPACK FOOTER //
// ./src/components/StationLinkDelete.js